exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".new-transfer-dealer .responsible-dealer{-ms-flex-line-pack:justify;align-content:space-between;-ms-flex-align:center;align-items:center;color:#aaa;display:-ms-flexbox;display:flex;-ms-flex-wrap:wrap;flex-wrap:wrap;font-size:1.4rem;min-height:40px;padding-bottom:10px}.new-transfer-dealer .dealer-address,.new-transfer-dealer .dealer-city-state-zip,.new-transfer-dealer .dealer-email,.new-transfer-dealer .dealer-name,.new-transfer-dealer .dealer-phone{padding-bottom:5px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/sass-loader!./src/rga/recalled-part-analysis/components/advance-returned-part-information/recalled-part-tab/components/new-transfer-dealer.scss
// module id = 5212
// module chunks = 0